import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { breakpointAtLeast } from './utils.js';

Chart.register(
  ChartDataLabels,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip,
);

(function ($) {
  /**
   * Initiate Bonds graph, only on Investors template.
   */
  if (
    $('body').hasClass('page-template-template-investor-relations-v2') &&
    $('#bonds-chart').length > 0
  ) {
    var chartElem = document.getElementById('bonds-chart');
    Chart.defaults.font.family = 'Avenir';
    Chart.defaults.font.size = 14;

    // Values on Y-Axis, keys represent years on X-axis
    var yValues4 = ['', 44.9, '']; // SK IV
    // const yValues5a = ['', '']; // SK V
    // const yValues5b = ['', '']; // SK V
    // const yValues5c = ['', '']; // SK V
    // const yValues6 = [22.6, '', '']; // SK VI
    // const yValues7a = ['', '']; // SK VII
    // const yValues7b = ['', '']; // SK VII
    // const yValues7bb = ['', '']; // SK VII
    // const yValues71 = [6.3, '']; // SK VIII
    const yValues72 = [11.2, '', '']; // SK IX
    const yValues73alt = ['', '', 25]; // SK IX alt
    const yValues74alt = ['', '', 25]; // SK IX alt
    // const yValues74 = [49.9, '']; // SK IX alt
    const yValues75 = ['', 46.1]; // SK IX #4
    // const yValues81 = ['', '']; // CZ II
    // const yValues82 = ['', '']; // CZ II

    // Values for columns
    var xValues = [2026, 2027, 2030];

    // Color used from https://brand.hbreavis.com/
    const bondsChart = new Chart(chartElem, {
      type: 'bar',
      data: {
        labels: xValues,
        datasets: [
          // !!! NOTE: Also don't forget to check datasets indexes in filter below !!!
          {
            label: 'HB REAVIS Finance SK IV s. r. o.',
            data: yValues4,
            backgroundColor: '#2660A4',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          // {
          //   label: 'HB REAVIS Finance SK V s. r. o.',
          //   data: yValues5a,
          //   backgroundColor: '#5A2B7F',
          //   borderWidth: {
          //     top: 1,
          //   },
          //   borderColor: '#fff',
          // },
          // {
          // {
          //   label: 'HB REAVIS Finance SK VI s. r. o.',
          //   data: yValues6,
          //   backgroundColor: '#C47335',
          //   borderWidth: {
          //     top: 1,
          //   },
          //   borderColor: '#fff',
          // },
          // {
          //   label: 'HB REAVIS Finance SK VII s. r. o.',
          //   data: yValues7a,
          //   backgroundColor: '#FFCB05',
          //   borderWidth: {
          //     top: 1,
          //   },
          //   borderColor: '#fff',
          //   datalabels: {
          //     display: 'auto',
          //   },
          // },
          // {
          //   label: 'HB REAVIS Finance SK VIII s. r. o.',
          //   data: yValues71,
          //   backgroundColor: '#F25CB5',
          //   borderWidth: {
          //     top: 1,
          //   },
          //   borderColor: '#fff',
          // },
          {
            label: 'HB REAVIS Finance SK IX s. r. o.',
            data: yValues72,
            backgroundColor: '#e52912',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          {
            label: 'HB REAVIS Finance SK XI s. r. o.',
            data: yValues73alt,
            backgroundColor: '#d86661',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          {
            label: 'HB REAVIS Finance SK XI s. r. o.',
            data: yValues74alt,
            backgroundColor: '#d86661',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          {
            label: 'HB REAVIS Finance SK IX s. r. o.',
            data: yValues75,
            backgroundColor: '#e52912',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          // {
          //   label: 'HB REAVIS Finance CZ II, s. r. o.',
          //   data: yValues81,
          //   backgroundColor: '#A6CE39',
          //   borderWidth: {
          //     top: 1,
          //   },
          //   borderColor: '#fff',
          // },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // set to false for better responsiveness
        onResize: function (chart, newSize) {
          // Adjust bar size on mobile
          if (breakpointAtLeast('medium')) {
            chart.options.datasets.bar.barPercentage = 0.4;
          } else {
            chart.options.datasets.bar.barPercentage = 1;
          }
        },
        datasets: {
          bar: {
            barPercentage: 0.4,
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            },
          },
          y: {
            stacked: true,
            grid: {
              drawBorder: false,
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            },
          },
        },
        plugins: {
          legend: {
            onClick: function () {
              // Disable click event
              return false;
            },
            labels: {
              boxWidth: 20,
              padding: 20,
              generateLabels: function (chart) {
                const datasets = chart.data.datasets;
                const metas = chart._getSortedDatasetMetas();

                // Filter out duplicated labels
                const filteredMetas = metas.filter((value, index, self) => {
                  // Leave this as duplicated legend for SK XI
                  // if (
                  //   index === 4 &&
                  //   value._dataset.backgroundColor === '#d86661'
                  // ) {
                  //   return true;
                  // }

                  return (
                    index === self.findIndex((t) => t.label === value.label)
                  );
                });

                // Use default generate function from chart.js dist
                const {
                  labels: { usePointStyle, pointStyle, textAlign, color },
                } = chart.legend.options;

                return filteredMetas.map((meta) => {
                  const style = meta.controller.getStyle(
                    usePointStyle ? 0 : undefined,
                  );

                  // const borderWidth = toPadding(style.borderWidth);
                  return {
                    text: datasets[meta.index].label,
                    fillStyle: style.backgroundColor,
                    fontColor: color,
                    hidden: !meta.visible,
                    lineCap: style.borderCapStyle,
                    lineDash: style.borderDash,
                    lineDashOffset: style.borderDashOffset,
                    lineJoin: style.borderJoinStyle,
                    // lineWidth: (borderWidth.width + borderWidth.height) / 4,
                    strokeStyle: style.borderColor,
                    pointStyle: pointStyle || style.pointStyle,
                    rotation: style.rotation,
                    textAlign: textAlign || style.textAlign,
                    borderRadius: 0,
                    datasetIndex: meta.index,
                  };
                }, this);
              },
            },
          },
          tooltip: {
            titleMarginBottom: 0,
            cornerRadius: 0,
            padding: 5,
            callbacks: {
              title: function (tooltipItem) {
                // Display label from dataset instead of default one
                // tooltipItem is array, thats why we need to use [0]
                const label =
                  `${tooltipItem[0].dataset.label}\n${
                    GLOBAL.chart_issue_size_label
                  }: ${tooltipItem[0].formattedValue}mil. EUR` || '';

                return label;
              },
              label: function () {
                // Disable default label
                return;
              },
            },
          },
          // Align labels inside datasets
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            color: '#fff',
            font: {
              size: 12,
            },
          },
        },
      },
      plugins: [
        {
          beforeInit(chart) {
            // Get reference to the original fit function
            const originalFit = chart.legend.fit;

            // Override the fit function
            chart.legend.fit = function fit() {
              // Call original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              // Change the height as suggested in another answers
              this.height += 20;
            };
          },
        },
      ],
    });
  }

  // Initialize REIT bonds chart
  if (
    $('body').hasClass('page-template-template-investor-relations-v2') &&
    $('#bonds-chart-reit').length > 0
  ) {
    var chartElem = document.getElementById('bonds-chart-reit');
    Chart.defaults.font.family = 'Avenir';
    Chart.defaults.font.size = 14;

    // Values on Y-Axis, keys represent years on X-axis
    var yValues4 = [15, '']; // SK
    const yValues5 = ['', 77.1]; // CZ III

    // Values for columns
    var xValues = [2029, 2030];

    // Color used from https://brand.hbreavis.com/
    const bondsChart = new Chart(chartElem, {
      type: 'bar',
      data: {
        labels: xValues,
        datasets: [
          // !!! NOTE: Also don't forget to check datasets indexes in filter below !!!
          {
            label: 'HB REAVIS Investments Finance SK s. r. o.',
            data: yValues4,
            backgroundColor: '#2660A4',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
          {
            label: 'HB REAVIS Finance CZ III s. r. o.',
            data: yValues5,
            backgroundColor: '#5A2B7F',
            borderWidth: {
              top: 1,
            },
            borderColor: '#fff',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // set to false for better responsiveness
        onResize: function (chart, newSize) {
          // Adjust bar size on mobile
          if (breakpointAtLeast('medium')) {
            chart.options.datasets.bar.barPercentage = 0.4;
          } else {
            chart.options.datasets.bar.barPercentage = 1;
          }
        },
        datasets: {
          bar: {
            barPercentage: 0.4,
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              drawOnChartArea: false,
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            },
          },
          y: {
            stacked: true,
            grid: {
              drawBorder: false,
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            },
          },
        },
        plugins: {
          legend: {
            onClick: function () {
              // Disable click event
              return false;
            },
            labels: {
              boxWidth: 20,
              padding: 20,
              generateLabels: function (chart) {
                const datasets = chart.data.datasets;
                const metas = chart._getSortedDatasetMetas();

                // Filter out duplicated labels
                const filteredMetas = metas.filter(
                  (value, index, self) =>
                    index === self.findIndex((t) => t.label === value.label),
                );

                // Use default generate function from chart.js dist
                const {
                  labels: { usePointStyle, pointStyle, textAlign, color },
                } = chart.legend.options;

                return filteredMetas.map((meta) => {
                  const style = meta.controller.getStyle(
                    usePointStyle ? 0 : undefined,
                  );

                  // const borderWidth = toPadding(style.borderWidth);
                  return {
                    text: datasets[meta.index].label,
                    fillStyle: style.backgroundColor,
                    fontColor: color,
                    hidden: !meta.visible,
                    lineCap: style.borderCapStyle,
                    lineDash: style.borderDash,
                    lineDashOffset: style.borderDashOffset,
                    lineJoin: style.borderJoinStyle,
                    // lineWidth: (borderWidth.width + borderWidth.height) / 4,
                    strokeStyle: style.borderColor,
                    pointStyle: pointStyle || style.pointStyle,
                    rotation: style.rotation,
                    textAlign: textAlign || style.textAlign,
                    borderRadius: 0,
                    datasetIndex: meta.index,
                  };
                }, this);
              },
            },
          },
          tooltip: {
            titleMarginBottom: 0,
            cornerRadius: 0,
            padding: 5,
            callbacks: {
              title: function (tooltipItem) {
                // Display label from dataset instead of default one
                // tooltipItem is array, thats why we need to use [0]
                const label =
                  `${tooltipItem[0].dataset.label}\n${
                    GLOBAL.chart_issue_size_label
                  }: ${tooltipItem[0].formattedValue}mil. EUR` || '';

                return label;
              },
              label: function () {
                // Disable default label
                return;
              },
            },
          },
          // Align labels inside datasets
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
            color: '#fff',
            font: {
              size: 12,
            },
          },
        },
      },
      plugins: [
        {
          beforeInit(chart) {
            // Get reference to the original fit function
            const originalFit = chart.legend.fit;

            // Override the fit function
            chart.legend.fit = function fit() {
              // Call original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              // Change the height as suggested in another answers
              this.height += 20;
            };
          },
        },
      ],
    });
  }
})(jQuery);
